<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <v-btn text v-on="on" @click="handleMenuClick">
        <v-icon small class="pr-1">fa-user-friends</v-icon>
        <span class="pr-1 text-none hidden-sm-and-down">{{ agricultor.nombre }}</span>
      </v-btn>
    </template>
    <v-list :class="{'hidden-md-and-up': isFilteredAgricultorListEmpty}" class="fh-menu-scroll">
      <v-list-item class="hidden-md-and-up" color="green">
        <v-list-item-title>{{ agricultor.nombre }}</v-list-item-title>
      </v-list-item>
      <v-divider v-if="!isFilteredAgricultorListEmpty" class="hidden-md-and-up"></v-divider>
      <template v-if="!isFilteredAgricultorListEmpty">
        <v-text-field
            v-if="showSearchField"
            v-model="search"
            append-icon="fa-search"
            label="Buscar"
            ref="input"
            single-line
            hide-details
            @click.stop=""
            class="px-3 py-2"
        ></v-text-field>
        <v-list-item
            v-for="agricultor in searchFilteredAgricultorList"
            :key="agricultor.agricultor.idAgricultor"
            @click="handleElegirAgricultor(agricultor.agricultor.idAgricultor)"
        >
          <v-list-item-title>{{ agricultor.agricultor.nombre }}</v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
  import {mapActions, mapGetters, mapState} from 'vuex'

  export default {
    name: 'FhMenuAgricultor',
    data() {
      return {
        search: '',
        filteredLength: 5,
      }
    },
    computed: {
      ...mapState('agricultor', [
        'agricultor'
      ]),
      ...mapState('session', [
        'isRestored',
      ]),
      ...mapGetters('agricultor', [
        'filteredAgricultorList'
      ]),...mapState('establecimientos', [
        'establecimiento',
        'establecimientosList',
      ]),
      isFilteredAgricultorListEmpty() {
        return this.filteredAgricultorList.length === 0
      },
      searchFilteredAgricultorList() {
        return this.filteredAgricultorList.filter(agricultor => agricultor.agricultor.nombre.toLowerCase().includes(this.search.toLowerCase()))
      },
      showSearchField() {
        return this.filteredAgricultorList.length >= this.filteredLength
      },
    },
    methods: {
      ...mapActions('agricultor', [
        'setAgricultor',
        'fetchAgricultorList',
      ]),
      ...mapActions('temporada', [
        'clearTemporadaAgricultor',
      ]),
      ...mapActions('establecimientos',[
        'fetchEstablecimientosList',
        'clearEstablecimiento',
        'clearEstablecimientoList',
        'setEstablecimiento',
      ]),
      async handleElegirAgricultor(id) {
        this.search = ''
        let payload = {idAgricultor: id, establecimiento: null}
        
        await this.clearTemporadaAgricultor()
        await this.clearEstablecimiento()
        await this.clearEstablecimientoList()
        await this.fetchEstablecimientosList(id)

        if(this.establecimientosList.length !== 0){
          payload.establecimiento = this.establecimientosList[0]
        }
        
        await this.clearEstablecimiento()
        await this.setAgricultor(payload)

        if(this.establecimientosList.length !== 0){
          this.$router.push({name: 'AgroHome'}).catch(() => {})
        }
        else{
          this.$router.push({name: 'CrearEstablecimiento'}).catch((e)=>{})
        }
      },
      handleMenuClick() {
        if (this.showSearchField) {
          setTimeout(() => {
            if (this.$refs.input) {
              this.$refs.input.focus()
            }
            }, 100)
        }
      },
    },
    async created() {
      // To prevent a race condition when session isn't restored yet
      while (!this.isRestored) {
        await this.$sleep(10)
      }
      // await this.fetchAgricultorList()
    }
  }
</script>

<style scoped>
  .fh-menu-scroll {
    overflow-y: auto;
    max-height: 90vh;
  }
</style>
